import React, { FC } from 'react'
import Dialog from '@pixel/core/Dialog'
import { styled } from '@pixel/core/styles'
import { LocalizedText } from '../../contexts/Localization/LocalizationTypes'
import { AssociatedAutomation, FieldListSearchResult } from '../types/FieldList'
import DialogContent from "@pixel/core/DialogContent";
import DialogActions from "@pixel/core/DialogActions";
import LocalizedButton from "../../components/LocalizedButton";
import { Typography } from '@pixel/core'

const SubtitleText = styled(Typography)(({ theme }) => ({
    color: '#808080',
    size: '14px',
    fontWeight: 400,
    paddingTop: theme.spacing(2),
}));

interface FieldListStatusAlertProps {
    selectedFieldList: FieldListSearchResult;
    associatedAutomations: Array<AssociatedAutomation>;
    open: boolean;
    onClose: () => void;
}

export const FieldListStatusAlert: FC<FieldListStatusAlertProps> = ({
    selectedFieldList,
    associatedAutomations,
    open,
    onClose,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogContent
                sx={{ width: 520 }}
            >
                <Typography variant="h2">
                    {window.i18n.automationEngine.FIELD_LIST_STATUS_MAKE_INACTIVE.replace(':name', selectedFieldList?.name)}
                </Typography>
                <SubtitleText variant="body1">
                    {window.i18n.automationEngine.FIELD_LIST_STATUS_MAKE_INACTIVE_SUBTITLE.replace(':name', selectedFieldList?.name)}
                </SubtitleText>
                {associatedAutomations.length ?
                    <>
                        <br/>
                        <ul>
                            {associatedAutomations.map((associatedAutomation: AssociatedAutomation) =>
                                <li key={associatedAutomation.companyAutomationId}>{associatedAutomation.companyAutomationName}</li>)}
                        </ul>
                    </> : null}
            </DialogContent>
            <DialogActions>
                <LocalizedButton
                    text={LocalizedText.Cancel}
                    variant="text"
                    color="secondary"
                    onClick={onClose}
                />
                <a href={window.location.href.replace('fieldlists', 'automationsettings')}>
                    <LocalizedButton
                        text={LocalizedText.FIELD_LIST_STATUS_MAKE_INACTIVE_GO_TO_AUTOMATIONS}
                        variant="contained"
                        color="primary"
                    />
                </a>
            </DialogActions>
        </Dialog>
    );
};
export default FieldListStatusAlert;
